angular.module('ihestiaCommonDirectives.pkdHelper', [
  'ihestiaCommonDirectives.configHelper',
  'ihestiaRestServicesBase',
  'ihestiaCommonDirectives.polishGrama',
  'ihestiaCommonDirectives.tryEscapeHtml'
  ]);